import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class DataPickerService {
  get baseUrl(): any {
    return `${this.datacollectorservice.baseurl()}`;
  }
  get pickerAPIUrls(): any{
    return {
      userListUrl: `${this.baseUrl}/user/all`,
      jobsCategoryUrl: `${this.baseUrl}/jobs/category`,
      customersCategoryUrl: `${this.baseUrl}/customers/category`,
      organizationUrl: `${this.baseUrl}/organization`,
      customerUrl: `${this.baseUrl}/customers`,
      newCustomerUrl: `${this.baseUrl}/customers_new`,
      customerCategoryUrl: `${this.baseUrl}/customers/category`,
      propertyUrl: `${this.baseUrl}/property`,
      assetsCategoryUrl: `${this.baseUrl}/assets/category`,
      assetUrl: `${this.baseUrl}/assets`
    };
  }
  public value: any;
  private subject = new Subject();

  constructor(
    private datacollectorservice: DataCollectorService,
    private formBuilder: UntypedFormBuilder) { }

  get onInit(): Observable<any> {
    return this.subject.asObservable();
  }

  setValue(value: any): void {
    this.value = value;
    this.subject.next(this.value);
  }

  createFormControls(formControls: any[]): UntypedFormGroup {
    const objectModel: any = {};
    formControls.forEach((control: any) => {
      if (control.controls) {
        objectModel[control.formControlName] = this.formBuilder.group(this.createNestedFormControls(control.controls, {}));
      } else {
        objectModel[control.formControlName] = [control.value, control.validators];
      }
    });
    return this.formBuilder.group(objectModel);
  }

  createNestedFormControls(controls: any[], objectModel: any): any {
    controls.forEach((control: any) => {
      if (control.controls) {
        objectModel[control.formControlName] = this.formBuilder.group(this.createNestedFormControls(control.controls, {}));
      } else {
        objectModel[control.formControlName] = [control.value, control.validators];
      }
    });
    return objectModel;
  }

  scrollToFirstInvalidControl(rootElement: any): void {
    if (rootElement) {
      const firstInvalidControl: HTMLElement = rootElement.querySelector('form .ng-invalid');
      firstInvalidControl?.scrollIntoView();
      firstInvalidControl?.focus();
    }
  }
}
